var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-container",
    { staticClass: "px-0 position-relative", attrs: { fluid: "" } },
    [
      _c(
        "b-carousel",
        {
          attrs: {
            id: "carousel-1",
            interval: 4000,
            fade: "",
            background: "#ababab",
            "img-width": "100vw",
            "img-height": "63%"
          }
        },
        [
          !_vm.isDonationPage && !_vm.isPremiumPage
            ? _c("b-carousel-slide", { attrs: { "img-src": _vm.bgLanding } }, [
                _c(
                  "div",
                  {
                    staticClass: "d-flex flex-column w-57 ",
                    staticStyle: { "padding-bottom": "8%" }
                  },
                  [
                    _c("span", { staticClass: "slider-title text-left" }, [
                      _vm._v("Login or Register")
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "slider-image-topup" }, [
                  _c("img", {
                    attrs: { src: require("@/assets/phone-slider.png") }
                  })
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.isDonationPage
            ? _c(
                "b-carousel-slide",
                { attrs: { "img-src": _vm.bgDonationsSlider } },
                [
                  _c(
                    "div",
                    {
                      staticClass: "d-flex flex-column w-51 ",
                      staticStyle: { "padding-bottom": "8%" }
                    },
                    [
                      _c("span", { staticClass: "slider-title text-left" }, [
                        _vm._v("Missions")
                      ]),
                      _vm._v(" "),
                      _c(
                        "p",
                        {
                          staticClass: "text-left",
                          staticStyle: { "margin-bottom": "4px" }
                        },
                        [_vm._v("Donate to MusicVerse to support missions")]
                      ),
                      _vm._v(" "),
                      _c("p", { staticClass: "text-left" }, [
                        _vm._v(
                          "MusicVerse is also a 501c3 organization that can provide tax deductible receipts for US donors"
                        )
                      ])
                    ]
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isPremiumPage
            ? _c(
                "b-carousel-slide",
                { attrs: { "img-src": _vm.bgSubscribeSlider } },
                [
                  _c(
                    "div",
                    {
                      staticClass: "d-flex flex-column w-57 ",
                      staticStyle: { "padding-bottom": "8%" }
                    },
                    [
                      _c("span", { staticClass: "slider-title text-left" }, [
                        _vm._v("Go Premium for as low as $1!")
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "text-left" }, [
                        _vm._v(
                          "Enjoy listening to songs in full, listen to songs offline, and share to missions. Cancel anytime!"
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "d-flex" }, [
                        _c(
                          "a",
                          {
                            staticClass: "learn-more ",
                            staticStyle: { width: "210px", cursor: "pointer" },
                            attrs: { align: "center" },
                            on: {
                              click: function($event) {
                                return _vm.gotToRoute("subscribe")
                              }
                            }
                          },
                          [_vm._v("Go Premium")]
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "slider-image-subscribe" }, [
                    _c("img", {
                      attrs: { src: require("@/assets/person-subscribe.png") }
                    })
                  ])
                ]
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7f846a02", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f846a02","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/HeaderLandingContent.vue
// module id = null
// module chunks = 